import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function GoToLoginButton({ path }: { path: string }) {
  const { t } = useTranslation();

  return (
    <Link to={path} style={{ textDecoration: "none" }}>
      <Typography variant="body2" color="secondary" sx={{ marginTop: 1 }}>
        {t("login.goToAuth")}
      </Typography>
    </Link>
  );
}
